import type { ResolvedBetterstartConfig } from '@cli-types/core-engine/config.js'
import { BARREL_SCOPE } from '@cli-constants/snapshots.js'
import { applyGeneratedFiles } from '@next-adapter/snapshots/apply/apply-generated-files.js'
import { renderBarrelFiles } from '@next-adapter/snapshots/barrels/render-barrel-files.js'

export async function regenerateBarrels(
  cwd: string,
  config: ResolvedBetterstartConfig
): Promise<void> {
  await applyGeneratedFiles({
    cwd,
    config,
    scope: BARREL_SCOPE,
    schemaJson: { name: BARREL_SCOPE },
    generatedFiles: renderBarrelFiles(cwd, config),
    force: false,
    interactive: false
  })
}
